import { Input } from '@velocity/ui'
import { useMemo } from 'react'

import { useContent } from '@ngb-frontend/shared/context'
import { validation as v } from '@ngb-frontend/shared/utils'

import { FormField } from '../FormField/FormField'

import type { FormFieldWrapper } from '@ngb-frontend/shared/types'

export const MileageField: React.FC<
  FormFieldWrapper & { placeholder?: string }
> = ({
  classes,
  label,
  hideLabel,
  name = 'mileage',
  noMargin,
  placeholder,
}) => {
  const c = useContent()
  const validator = useMemo(
    () => (value: string) => {
      const isValid = v.minMaxValue(
        v.validationDefaults.minMileageValue,
        v.validationDefaults.maxMileageValue,
      )(value)

      if (isValid) {
        return undefined
      }

      return {
        message: c('errors.mileage'),
        type: 'errorType',
      }
    },
    [c],
  )

  return (
    <FormField<string>
      name={name}
      label={label || c('fields.mileage.label')}
      hideLabel={hideLabel}
      id="mileage-input"
      validator={validator}
      classes={classes}
      noMargin={noMargin}
    >
      {({ input }) => (
        <Input
          inputProps={{
            'aria-label': 'mileage',
            'data-e2e-component': 'mileage-input',
          }}
          {...input}
          type="number"
          placeholder={placeholder}
          required={false}
          endAdornment={c('fields.mileage.mileageUnitAbbreviation')}
        />
      )}
    </FormField>
  )
}
